<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :searchData="searchData"
               :onSortChange="sortChange"
               tableApi="admin/gas/getStationByPlat"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="gas_name">
          <Input type="text" v-model="searchData.gas_name" placeholder="油站名称" class="lx-search-item"></Input>
        </FormItem>
      </template>

    </pageTable>

    <stationDetailForm v-if="showStationEdit"
                       :show-edit="showStationEdit"
                       :station_id="editStationId"
                       ref="editModel"
                       @cancel-edit="showStationEdit=false"
    >
    </stationDetailForm>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import stationDetailForm from "./detail";
  import XLSX from 'xlsx'
  export default {
    name: "station",
    components:{pageTable,stationDetailForm},
    data() {
      return {
        editUserId:0,     //编辑的ID
        showUserDetail:false,
        showStationEdit:false,
        editStationId:0,
        showAddForm:false,
        searchData: {
          gas_name: '',
          self_support:'',
          sortKey:'',
          sortType:''
        },
        tableColumn: [
          {title: '名称',key: 'gas_name',align: "left"},
          {title: '编号',key: 'gas_id',align: "left"},
          {title: '地址',key: 'gas_address',align: "left"},
          {title: '联系方式',key:'contact_user',align: "center",width:140,render:(h,params)=>{
              return h('div',[
                h('p',params.row.contact_user),
                h('p',params.row.contact_mobile),
              ])
            }},
          {title: '国标价格',key: 'price',align: "center",sortable: 'custom',},
          {title: '对内价格',key: 'price2',align: "center",},
          {title: '操作',render:(h,params)=>{
              return h('Button',{props:{type:'primary',size:'small'},on:{click:()=>{this.showDetail(params.row.station_id)}}},'查看')
            }},
          // {title: '注册时间',key:'create_time',align: "center"},
        ],
        tableData: [],
      }
    },
    methods: {
      sortChange(data){
        this.searchData.sortKey = data.key
        this.searchData.sortType = data.order
        this.$refs.table.changePage(1)
      },
      showDetail(station_id){
        this.showStationEdit = true
        this.editStationId = station_id
      },
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
